export default {
  inboxExpansion: {
    // transitionProperty: 'right',
    // transitionDuration: '200ms',
    // transitionDelay: '70ms',
  },
};
